/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

import { Component } from 'vue-property-decorator';
import BasicSearchPage from '../../../components/basicSearchPage/basicSearchPage';
import override from '../../../dectorators/override';
import AlarmStatisticsService from './service/alarmStatisticsService';
import { AlarmStatisticsDOI } from './api/alarmStatisticsApi';
import ECharts from 'vue-echarts';
import { createNamespace } from 'src/util/bem';
import EnumAlarmType from 'src/enums/enumAlarmType';
@Component
export default class AlarmStatistics extends BasicSearchPage<
    AlarmStatisticsService,
    AlarmStatisticsDOI.RowDataI,
    AlarmStatisticsDOI.QueryRowDataParamsI
> {
    checkBoxShow = false;
    className = createNamespace('pt0');
    pageShow = false;
    statistic:any = {}

    get option() {
        let t = this
        let alarms = EnumAlarmType.getList()
        return {
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)',
            },
            legend: {
                orient: 'vertical',
                left: 10,
                data: alarms.map(i => i.getName()),
                textStyle: {color: '#fff'},
                top: 'middle'
            },
            series: [
                {
                    name: '访问来源',
                    type: 'pie',
                    radius: ['45%', '65%'],
                    center: ['70%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '18',
                            fontWeight: 'bold',
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: alarms.map(i=> {
                        return { value: t.statistic[i.getCode()+'_count'], name: i.getName() }
                    }),
                },
            ],
        }
    }

    // 站点纬度的柱状图
    get stationOption() {
        let alarms = EnumAlarmType.getList()
        let source = this.rowData.map(i=> {
            let obj:any =  {
                station:i.name,
            }
            alarms.forEach(alarm=> {
                obj[alarm.getName()] = i[alarm.getCode()]
            })
            return obj
        })
        console.log('source', source)
        return {
            title: {
                text: '',
                textStyle: {
                    fontSize: 22,
                    color: '#fff',
                },
                left: 20,
                top: 15,
            },
            legend: {
                textStyle: {
                    fontSize: 16,
                    color: '#fff',
                },
                top: 15,
            },
            tooltip: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '20',
                containLabel: true,
            },
            dataset: {
                dimensions: ['station', ...alarms.map(i=>i.getName())],
                source: source
            },
            xAxis: {
                type: 'category',
                axisLabel: {
                    color: '#C3EBFF',
                    fontSize: 12,
                    width:20
                },
                axisLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                    },
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                        opacity: 0.2,
                    },
                },
            },
            yAxis: {
                axisLabel: {
                    color: '#02FB71',
                    fontSize: 16,
                },
                axisLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                        opacity: 0.2,
                    },
                },
            },
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: alarms.map(i=> ({type: 'bar'}))
        }
    }

    @override
    renderFooter(h) {
        return (
            <div style="flex:1;display:flex" class={createNamespace(['mt10']) + ' ag-theme-material'}>
                <div style="flex:3" >
                <ECharts style="width: 100%;height: 100%;" options={this.stationOption} auto-resize={true} />
                </div>
                <div style="flex:1" >
                    <ECharts style="width: 100%;height: 100%;" options={this.option} auto-resize={true} />
                </div>
            </div>
        );
    }

    @override
    loadService() {
        this.service = new AlarmStatisticsService(this);
    }
}
